import { NgModule } from '@angular/core';
import { DateInputComponent } from './date-input.component';
import { FormsModule } from '@angular/forms';
import { IconModule } from '../../icon/icon.module';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    declarations: [DateInputComponent],
    exports: [DateInputComponent],
    imports: [FormsModule, IconModule, MatIconModule],
})
export class DateInputComponentModule {
}